import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@emotion/css';

const sectionHeader = (params) => css`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  justify-content: center;
  width: 100%;
  color: ${params?.titleColor};
  font-size: ${params?.titleFontSize};
  font-weight: ${params?.titleFontWeight};

  height: 50px;
  & > span {
    text-overflow: ellipsis;
    overflow: hidden; 
    white-space: nowrap;
    max-width: 70%;
    text-decoration: underline;
  }
`;

const totalSelected = (params) => css`
  width: 1.6em;
  height: 1.6em;
  border-radius: 25px;
  border: 1px solid ${params.titleColor};
  margin-left: 7px;
  font-weight: normal;
  font-size: 0.7em;
  line-height: 1.6em;
  text-align: center;
`;

const FilterTitleMobile = ({ label, themeConfig, activeValueTotal }) => (
  <div className={cx(sectionHeader(themeConfig), themeConfig.titleFontType)}>
    <span>{label}</span>
    <div className={totalSelected(themeConfig)}>
      {activeValueTotal}
    </div>
  </div>
);

FilterTitleMobile.propTypes = {
  label: PropTypes.string,
  activeValueTotal: PropTypes.number,
  themeConfig: PropTypes.object,
};

export default FilterTitleMobile;
